module.exports = __webpack_public_path__ + "img/signbackground_0.09768e6a.png";